import { useRefCallback } from '@bydesign-ui/hooks';
import { useCallback, useEffect } from 'react';
import { useTable } from './useTable';
export function useColumnScroll(onUpdateScroll) {
  var table = useTable();
  var manager = table.getLeafColumnManager();
  var onUpdateScrollCallback = useRefCallback(onUpdateScroll);
  var onChange = useCallback(function (value, delta) {
    manager.updateNonFixedScroll(value + (delta ? Number(manager.getNonFixedScroll()) : 0));
  }, []);
  useEffect(function () {
    var callback = function callback(info) {
      onUpdateScrollCallback(info.scroll);
    };

    manager.addListener('scroll', callback);
    return function () {
      return manager.removeListener('scroll', callback);
    };
  }, []);
  return [manager.getColumnScrollInfo().scroll, onChange];
}